import { useEffect, useState } from 'react';

// Drop-in useState replacement persisted to sessionStorage — state survives
// tab switches, reloads and in-app navigation within one browser tab, and
// resets when the tab closes. Values must be JSON-serialisable. On storage
// errors (corrupt value, storage unavailable) it degrades to plain useState.
export function useSessionStorageState(key, initialValue) {
  const [state, setState] = useState(() => {
    try {
      const raw = sessionStorage.getItem(key);
      if (raw != null) {
        const parsed = JSON.parse(raw);
        // Shape guard: only accept a value of the same basic type as the
        // default (and never null), so an externally corrupted entry falls
        // back to the default instead of flowing into consumers.
        if (parsed != null && typeof parsed === typeof initialValue) {
          return parsed;
        }
      }
    } catch (error) {
      console.error(`Failed to load sessionStorage key ${key}:`, error);
    }
    return initialValue;
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(key, JSON.stringify(state));
    } catch (error) {
      console.error(`Failed to save sessionStorage key ${key}:`, error);
    }
  }, [key, state]);

  return [state, setState];
}
